import React from 'react';

const PlaceholderImage = ({ className = "", alt = "No image available" }) => {
  return (
    <div 
      className={`bg-gray-100 border border-gray-300 flex flex-col items-center justify-center text-gray-500 ${className}`}
    >
      <div className="w-6 h-6 bg-gray-300 rounded-full flex items-center justify-center mb-1">
        <svg 
          className="w-3 h-3 text-gray-500" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" 
          />
        </svg>
      </div>
      <span className="text-xs font-medium">No Image</span>
    </div>
  );
};

export default PlaceholderImage;
